import * as _ from 'lodash';
import { SeatStatus, SeatStatusInfo } from './seatStatus';

export class TeamStatusCount {
  get rank(): number {
    return SeatStatusInfo.sortRanking(this.status);
  }
  get isEmpty(): boolean {
    return _.isNil(this.status);
  }
  get formattedStatus(): string {
    if (this.isEmpty) return 'Empty';
    return SeatStatus[this.status];
  }
  constructor(public status?: SeatStatus, public count?: number) {}
}
